import Cookies from 'js-cookie'
import { AUTH__LOGOUT } from '../store/actions'

import { UTILS__VALIDATOR__is_value } from '../utils/validator'

import { MAIN_SERVER } from './instance'
import store from '../store'

export const DELETE = async userId => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        userId = optionalId
    }

    return MAIN_SERVER({
        method: 'delete',
        url: `/users/${userId}`,
    })
}

export const GET_DETAILS = async userId => {
    try {
        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            userId = optionalId
        }

        let user = await MAIN_SERVER({
            method: 'get',
            url: `/users/${userId}`,
        })

        // Add CID if not exist and not admin
        if (!user.cid && !optionalId) {
            try {
                const ga = Cookies.get('_ga')
                if (typeof ga !== 'undefined') {
                    user = await MAIN_SERVER({
                        method: 'put',
                        url: `/users/${user.id}`,
                        data: {
                            ...user,
                            cid: ga,
                        },
                    })
                }
            } catch (err) {
                console.error(err)
            }
        }

        return user
    } catch (err) {
        if (err.response) {
            const {
                response: { status },
            } = err
            if (status === 404) {
                await store.dispatch(AUTH__LOGOUT())
            }
        }
        throw err
    }
}

export const UPDATE_DETAILS = async (userId, data) => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        userId = optionalId
    }

    return MAIN_SERVER({
        method: 'put',
        url: `/users/${userId}`,
        data,
    })
}
export const CHANGE_PASSWORD = async (userId, data) => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        userId = optionalId
    }

    return MAIN_SERVER({
        method: 'patch',
        url: `/users/${userId}/changepassword`,
        data,
    })
}

export const GET_RESTORE_PASSWORD_CODE = async obj => {
    try {
        const data = {}
        if (UTILS__VALIDATOR__is_value(obj.email)) {
            data.email = obj.email
        }

        return await MAIN_SERVER({
            method: 'post',
            url: '/users/forgot',
            headers: {
                'Content-Type': 'application/json',
            },
            data,
        })
    } catch (err) {
        throw err
    }
}

export const ACTIVATE = async obj => {
    try {
        const params = {}
        if (UTILS__VALIDATOR__is_value(obj.code)) {
            params.activationCode = obj.code
        }

        return await MAIN_SERVER({
            method: 'get',
            url: '/users/activate',
            headers: {
                'Content-Type': 'application/json',
            },
            params,
        })
    } catch (err) {
        throw err
    }
}

export const RESTORE_PASSWORD = async obj => {
    try {
        const data = {}
        if (UTILS__VALIDATOR__is_value(obj.email)) {
            data.login = obj.email
        }
        if (UTILS__VALIDATOR__is_value(obj.password)) {
            data.newPassword = obj.password
        }
        if (UTILS__VALIDATOR__is_value(obj.code)) {
            data.verificationCode = obj.code
        }

        return await MAIN_SERVER({
            method: 'patch',
            url: '/users/forgot',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        })
    } catch (err) {
        throw err
    }
}

export const RESEND_ACTIVATION_LINK = async login =>
    MAIN_SERVER({
        method: 'post',
        url: '/users/activation/resend',
        headers: {
            'Content-Type': 'application/json',
        },
        data: login,
    })

export const GET_SUBSCRIPTIONS = user_id => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        user_id = optionalId
    }

    return MAIN_SERVER({
        method: 'get',
        url: `/users/${user_id}/subscriptions`,
    })
}

export const GET_SELECTED_SUBSCRIPTION = async user_id => {
    try {
        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            user_id = optionalId
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/users/${user_id}/selected-subscription`,
        })
    } catch (err) {
        throw err
    }
}

export const GET_SUBSCRIPTION_CONSTRAINTS = async subscription_id => {
    try {
        const params = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/subscriptions/${subscription_id}/constraints`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const DOWNGRADE_CURRENT_SUBSCRIPTION = (subscriptionId, productCode) => {
    const params = {}

    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        params.userId = optionalId
    }

    return MAIN_SERVER({
        method: 'patch',
        url: `/subscriptions/${subscriptionId}/downgrade-product/${productCode}`,
        params,
    })
}

export const CANCEL_DOWNGRADE = subscriptionId => {
    const params = {}

    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        params.userId = optionalId
    }

    return MAIN_SERVER({
        method: 'patch',
        url: `/subscriptions/${subscriptionId}/downgrade/cancel`,
        params,
    })
}

export const UPDATE_CURRENT_SUBSCRIPTION = (subscriptionId, update) => {
    const params = {}

    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        params.userId = optionalId
    }

    return MAIN_SERVER({
        method: 'patch',
        url: `/subscriptions/${subscriptionId}`,
        headers: {
            'Content-Type': 'application/json',
        },
        params,
        data: JSON.stringify(update),
    })
}

export const GET_NOTIFICATIONS = user_id => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        user_id = optionalId
    }

    return MAIN_SERVER({
        method: 'get',
        url: `/users/${user_id}/notifications`,
    })
}

export const SET_NOTIFICATION_READ = (user_id, notification_id) => {
    return MAIN_SERVER({
        method: 'patch',
        url: `/users/${user_id}/notifications/${notification_id}`,
        data: null,
    })
}

export const RESET_TRIAL = user_id => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        user_id = optionalId
    }

    return MAIN_SERVER({
        method: 'post',
        url: `/users/${user_id}/reset-trial`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: null,
    })
}

export const GET_TRIAL_COUNT = user_id => {
    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        user_id = optionalId
    }

    return MAIN_SERVER({
        method: 'get',
        url: `/users/${user_id}/reset-trial-count`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: null,
    })
}
